import React from 'react'
import { IFeature } from 'static/interfaces'
import { ISelectedGuests } from './reservation'
import moment from 'moment'
import {
  getSearchFiltersTotalGuestCount,
  updateSearchFiltersCookie,
  getSearchFiltersCookie,
} from './searchFiltersCookie'
import { pushDataLayer } from './googleTagManager'

interface IUseSearchFiltersArgs {
  date: moment.Moment | null
  guests: ISelectedGuests
  areaFeature: Pick<IFeature, 'id' | 'slug' | 'title'> | null
}

// TODO: 追々date, guests, areaFeatureをuseState込みでここで管理できるようにする
export const useSearchFilters = ({ date, guests, areaFeature }: IUseSearchFiltersArgs) => {
  const saveSearchFilters = React.useCallback(() => {
    const existingCookie = getSearchFiltersCookie()
    const nextDate = date ? date.format('YYYY-MM-DD') : null

    // ヘッダの検索から日付を変更した場合、日付範囲をリセットしヘッダの日付を採用する
    const hasDateChanged = existingCookie?.date !== nextDate
    const currentDateRange = existingCookie?.dateRange ?? null

    updateSearchFiltersCookie({
      areaFeature,
      date: nextDate,
      dateRange: hasDateChanged ? null : currentDateRange,
      guests,
    })
  }, [areaFeature, date, guests])

  const fireSearchEvent = React.useCallback(
    async (eventCallback?: () => void) => {
      let calling = false
      const guestCount = getSearchFiltersTotalGuestCount(guests)
      pushDataLayer({
        event: 'search',
        search_term: 'Filter Tours',
        filter_area: areaFeature?.title ?? '',
        filter_start_date: date ? date.format('YYYY-MM-DD') : '',
        filter_total_guests: guestCount,
        filter_page_url: window.location.href,
        eventCallback() {
          if (eventCallback) {
            calling = true
            eventCallback()
          }
        },
        eventTimeout: eventCallback ? 1000 : undefined,
      })

      // GTM の eventCallback が呼ばれないケースで待たせすぎないようにする対応
      if (eventCallback) {
        await new Promise(resolve => setTimeout(resolve, 1200))
        if (!calling) {
          eventCallback()
        }
      }
    },
    [areaFeature, date, guests]
  )

  return {
    fireSearchEvent,
    saveSearchFilters,
    searchHref: `/features/${areaFeature?.slug ?? 'japan'}`,
  }
}
